import { render, staticRenderFns } from "./FormPayOrderCertificate.vue?vue&type=template&id=aa3faa6c&scoped=true&"
var script = {}
import style0 from "./FormPayOrderCertificate.vue?vue&type=style&index=0&id=aa3faa6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa3faa6c",
  null
  
)

export default component.exports